(function ($) {
    $('form #phone').keypress(function () {
        var key = event.which || event.keyCode;
        if ((key == '43' || key == '48' || key == '49' || key == '50') || key == '51' || key == '52' || key == '53' ||
            key == '54' || key == '55' || key == '56' || key == '57' || key == '58' || key == '59' || key == '13') {
            $('form #phone-error').html('');
            $('form #phone').css({
                'border': 'none'
            });
            console.log('if');
            return true;
        } else {
            console.log(key);
            forn_error('form #phone', 'form #phone-error', 'Must contain only numbers');
            return false;
        }
    });

    $('form #position').on('change', function() {
        if (position == '') {
            forn_error('form #position', 'form #position-error', 'Please complete this required field.');
            return false;
        } else {
            $('form #position-error').html('');
            $('form select').css({
                'border': 'none'
            });
        }
    });
    $('body .join-us-form .form-container .form-wrap form input[type=submit]').click(function (e) {
        $('form input').css({
            'border': 'none'
        });
        $('form .error').html('');
        $('form input[type=submit]').css({
            'border': '1px solid #80bc00'
        });
        $('form select').css({
            'border': 'none'
        });
        e.preventDefault();
        var form_data = $('form').serialize();
        var url = '/wp-content/themes/wewp/templates/components/mail.php';
        var fname = $('form #fname').val();
        var lname = $('form #lname').val();
        var phone = $('form #phone').val();
        var email = $('form #email').val();
        var mlocal = $('form #local').val();
        var position = $('form #position').val();
        var atposition = email.indexOf("@");
        var dotposition = email.lastIndexOf(".");
        var response = grecaptcha.getResponse();
        if (fname == '') {
            forn_error('form #fname', 'form #fname-error', 'Please complete this required field.');
            return false;
        }
        if (lname == '') {
            forn_error('form #lname', 'form #lname-error', 'Please complete this required field.');
            return false;
        }
        if (phone == '') {
            forn_error('form #phone', 'form #phone-error', 'Please complete this required field.');
            return false;
        }
        if (phone.length < 9){
            forn_error('form #phone', 'form #phone-error', 'Please enter correct 10 digit number ');
            return false;
        }
        if (email == '') {
            forn_error('form #email', 'form #email-error', 'Please complete this required field.');
            return false;
        }
        if (email < 1 || dotposition < atposition + 2 || dotposition + 2 >= email.length) {
            forn_error('form #email', 'form #email-error', 'Email must be formatted correctly.');
            return false;
        }
        if (mlocal == '') {
            forn_error('form #local', 'form #mlocal-error', 'Please complete this required field.');
            return false;
        }
        if (position == '') {
            forn_error('form #position', 'form #position-error', 'Please complete this required field.');
            return false;
        }
    if (response.length === 0) {
        $('.msg-error').text("reCAPTCHA is mandatory");
        $('iframe').css({'border':'1px solid red'});
        $('recaptcha-checkbox-border').css({'border':'1px solid red'});
    }
        else {
        $('recaptcha-checkbox-border').css({'border':'none'});
        $.ajax({
                data: form_data,
                type: 'post',
                url: url,
                beforeSend: function () {
                    // alert('going to send ');
                },
                success: function (data) {
                    console.log(data);
                    $('body .join-us-form').addClass('thanks');
                },
                error: function (e) {
                    console.log(e);
                }
            });
        }
    });

    function forn_error(name, id, message) {
        $(name).css({'border': '1px solid red'});
        $(name).focus();
        $(id).html(message);
    }
})(jQuery);